import constants from "../constants.js";

const ProcessUploadStatusUploadedFilename = {
  displayName: "Uploaded Filename",
  dataAt: "UploadedFilename",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const ProcessUploadStatusProcessType = {
  displayName: "ProcessType",
  dataAt: "ProcessType",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const ProcessUploadStatusUploadedBy = {
  displayName: "Uploaded By",
  dataAt: "UploadedBy",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const ProcessUploadStatusUploadedOn = {
  displayName: "Uploaded On",
  dataAt: "UploadedOn",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const ProcessUploadStatusLastStatusChange = {
  displayName: "Last Status Change",
  dataAt: "LastStatusChange",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const ProcessUploadStatusStatus = {
  displayName: "Status",
  dataAt: "Status",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const ProcessUploadStatusNotes = {
  displayName: "Notes",
  dataAt: "Notes",
  displayAs: constants.DISPLAY_AS.TEXT_AREA,
  disabled: true
};

const ProcessUploadStatusViewResource = {
  displayName: "Process Upload Status",
  iconClass: "fa-gear",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    ProcessUploadStatusUploadedFilename,
    ProcessUploadStatusProcessType,
    ProcessUploadStatusUploadedBy,
    ProcessUploadStatusUploadedOn,
    ProcessUploadStatusLastStatusChange,
    ProcessUploadStatusStatus,
    ProcessUploadStatusNotes
  ],
  showBack: true,
  endpoint: "ProcessUploadStatus",
  routeParamId: "processUploadStatusId",
};

const ProcessUploadStatusGrid = {
  displayName: "Process Upload Status",
  displayAs: constants.DISPLAY_AS.PAGING_GRID,
  gridCols: [
    { name: "UploadedFilename", field: "UploadedFilename" },
    { name: "ProcessType", field: "ProcessType" },
    { name: "UploadedBy", field: "UploadedBy" },
    { name: "UploadedOn", field: "UploadedOn", cellFilter: 'dateDisplay',width: '165' },
    { name: "LastStatusChange", field: "LastStatusChange", cellFilter: 'dateDisplay',width: '165' },
    { name: "Status", field: "Status" },
    { name: "Notes", field: "Notes" },
  ],
  children: [
    ProcessUploadStatusUploadedFilename,
    ProcessUploadStatusUploadedBy,
    ProcessUploadStatusUploadedOn,
    ProcessUploadStatusLastStatusChange,
    ProcessUploadStatusStatus,
    ProcessUploadStatusNotes
  ],
  endpoint: "ProcessUploadStatus",
  filterColumns: "ProcessUploadStatusSearchTypes",
  defaultFilteredColumn: "UploadedFilename",
};

const ProcessUploadStatus = {
  rootNode: true,
  iconClass: "fa-gear",
  displayName: "Process Upload Status",
  showTitle: false,
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [ProcessUploadStatusGrid],
};

export default {
  ProcessUploadStatus,
  ProcessUploadStatusGrid,
  ProcessUploadStatusViewResource,
  ProcessUploadStatusUploadedFilename,
  ProcessUploadStatusUploadedBy,
  ProcessUploadStatusUploadedOn,
  ProcessUploadStatusLastStatusChange,
  ProcessUploadStatusStatus,
  ProcessUploadStatusNotes
};



// WEBPACK FOOTER //
// ./src/config/fields/processUploadStatus.js